import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RutaCriticaService } from './services/ruta-critica.service';
import { IGuardarRutaCriticaProcesoRequest, IEditarRutaCriticaProcesoRequest } from './interfaces/ruta-critica.interface';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';
import { MatDialog } from '@angular/material/dialog';
import { RutasDialogComponent } from './rutas-dialog.component';
import { ActividadesDialogComponent } from './actividades-dialog.component';
@Component({
  selector: 'app-ruta-critica-form',
  templateUrl: './ruta-critica-form.component.html'
})
export class RutaCriticaFormComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<{refresh: boolean, numero_Proceso?: number, success?: boolean}>();
  @Input() model: any = null;

  form: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private rutaCriticaService: RutaCriticaService,
    private dialog: MatDialog
  ) {
    this.form = this.fb.group({
      numero_Proceso: ['', [Validators.required]],
      descriptivo: ['', [Validators.required]],
      duracion: [0, [Validators.required, Validators.min(0)]],
      costo: [0, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnInit(): void {
    this.setForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && changes['model'].currentValue) {
      this.setForm();
    } else if (changes['visible'] && changes['visible'].currentValue) {
      if (this.model) {
        this.loadProcesoByNumero(this.model.numero_Proceso);
      } else {
        this.form.reset();
        this.form.controls['numero_Proceso'].enable();
      }
    }
  }

  setForm(): void {
    if (this.model) {
      this.loadProcesoByNumero(this.model.numero_Proceso);
    } else {
      this.form.reset();
      this.form.controls['numero_Proceso'].enable();
    }
  }

  loadProcesoByNumero(numero_Proceso: number) {
    this.loading = true;
    const payload: IEditarRutaCriticaProcesoRequest = {
      numero_proceso: numero_Proceso,
      descripcion: '',
      descriptivo: '',
      duracion: 0,
      costo: 0
    };
    this.rutaCriticaService.getProcesoVar(payload).subscribe({
      next: (res) => {
        if (res.success && res.data.length > 0) {
          const proceso = res.data[0];
          this.form.patchValue({
            numero_Proceso: proceso.numero_proceso,
            descripcion: proceso.descriptivo,
            descriptivo: proceso.descriptivo,
            duracion: proceso.duracion,
            costo: proceso.costo
          });
          this.form.controls['numero_Proceso'].disable();
        }
      },
      complete: () => this.loading = false
    });
  }

  create() {
    if (this.form.valid) {
      this.loading = true;
      const payload: IGuardarRutaCriticaProcesoRequest = {
        que: 1,
        numero_proceso: this.form.get('numero_Proceso')?.value,
        descripcion: '',
        descriptivo: this.form.get('descriptivo')?.value,
        duracion: this.form.get('duracion')?.value,
        costo: this.form.get('costo')?.value
      };
      this.rutaCriticaService.guardarProceso(payload).subscribe({
        next: (res) => {
          this.visible = false;
          this.visibleChange.emit({refresh: true, numero_Proceso: payload.numero_proceso, success: res.success});
        },
        error: () => {
          this.visible = false;
          this.visibleChange.emit({refresh: false, numero_Proceso: payload.numero_proceso, success: false});
        },
        complete: () => this.loading = false
      });
    }
  }

  update() {
    if (this.form.valid && this.model) {
      this.loading = true;
      const payload: IGuardarRutaCriticaProcesoRequest = {
        que: 2,
        numero_proceso: this.form.get('numero_Proceso')?.value,
        descripcion: '',
        descriptivo: this.form.get('descriptivo')?.value,
        duracion: this.form.get('duracion')?.value,
        costo: this.form.get('costo')?.value
      };
      this.rutaCriticaService.guardarProceso(payload).subscribe({
        next: (res) => {
          this.visible = false;
          this.visibleChange.emit({refresh: true, numero_Proceso: payload.numero_proceso, success: res.success});
        },
        error: () => {
          this.visible = false;
          this.visibleChange.emit({refresh: false, numero_Proceso: payload.numero_proceso, success: false});
        },
        complete: () => this.loading = false
      });
    }
  }

  close(refresh: boolean = false) {
    this.visible = false;
    this.visibleChange.emit({refresh});
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'rutas',
        sClave: `${this.form.get('numero_Proceso')?.value}`,
        sNombre: this.form.get('descriptivo')?.value,
        sTipo: 'Opcion'
      }
    });
  }

  openRutasDialog(): void {
    this.dialog.open(RutasDialogComponent, {
      width: '900px',
      height: '700px',
      disableClose: false,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        proceso: this.form.get('numero_Proceso')?.value
      }
    });
  }

  openActividadesDialog() {
    this.dialog.open(ActividadesDialogComponent, {
      width: '900px',
      height: '700px',
      disableClose: false,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: { proceso: this.form.get('numero_Proceso')?.value }
    });
  }
} 